import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Condition} from "@domain/workflow/condition";
import {ToastrService} from "ngx-toastr";
import {WorkflowConditionsService} from "@services/admin/workflow/workflow-conditions.service";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {filter,first} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";
import {Result,TypeCodeErreur} from "@domain/common/http/result";
import {ListItem} from "@domain/common/list-view/list-item";
import {Router} from "@angular/router";

/**
 * Item de la liste des alertes
 */
@Component({
	host: {'data-test-id': 'alerte-list-item'},
	templateUrl: './alerte-list-item.component.html'
})
export class AlerteListItemComponent extends ListViewItem<Condition> {
	/**
	 * Constructeur
	 *
	 * @param workflowConditionsService le service de gestion des conditions workflow
	 * @param router le routeur Angular
	 * @param confirmService le service de confirmation
	 * @param translateService le moteur de traduction
	 * @param toastrService le toaster
	 */
	constructor(
		private workflowConditionsService: WorkflowConditionsService,
		private router: Router,
		private confirmService: ConfirmService,
		private translateService: TranslateService,
		private toastrService: ToastrService
	) {
		super();
	}

	/**
	 * Icône de l'alerte en fonction de sa portée
	 *
	 * @param idPortee la portée
	 */
	getIconeClass(idPortee: string): string {
		return WorkflowConditionsService.getClasseIcone(idPortee);
	}

	/**
	 * Navigation vers l'alerte
	 */
	onSelect(): void {
		this.router.navigate(['Admin/Workflow/Conditions/Alerte',this.data.idCondition]);
	}

	/**
	 * Suppression de l'alerte
	 */
	onDelete(): void {
		//Confirmation de l'action
		this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
			.pipe(filter(isConfirmed => isConfirmed))
			.subscribe(() => {
				//Appel au service
				this.workflowConditionsService.deleteAlerte(this.data.idCondition)
					.pipe(first())
					.subscribe((result: Result) => {
						//Vérification du résultat
						if (result.codeErreur == TypeCodeErreur.NO_ERROR) {
							//Toast succès
							this.toastrService.success(this.translateService.instant('global.success.suppression'));

							//Suppression de l'élément de la listView
							(this.data as ListItem).removeFromListView();
						} else {
							//Gestion de l'erreur
							TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
						}
					});
			});
	}
}
